var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.067 3.995c.563 0 1.065.353 1.255.883L19 6.765c.107.297.316.547.59.705l2.01 1.16c.272.158.592.214.903.158l1.974-.356c.554-.101 1.112.157 1.394.645l1.067 1.84a1.334 1.334 0 01-.134 1.53l-1.295 1.53c-.204.242-.316.547-.316.862v2.321c0 .316.112.621.316.862l1.295 1.532c.363.43.416 1.041.134 1.528l-1.067 1.84a1.334 1.334 0 01-1.393.646l-1.974-.356c-.31-.055-.63 0-.903.158l-2.01 1.16a1.342 1.342 0 00-.59.704l-.678 1.888c-.19.53-.693.884-1.256.883h-2.134a1.334 1.334 0 01-1.255-.883L13 25.235a1.346 1.346 0 00-.588-.705L10.4 23.37a1.334 1.334 0 00-.903-.158l-1.974.357a1.334 1.334 0 01-1.394-.646l-1.067-1.84a1.334 1.334 0 01.133-1.53l1.296-1.53c.204-.242.316-.547.316-.863v-2.32c0-.316-.112-.621-.316-.862l-1.282-1.531a1.334 1.334 0 01-.134-1.53l1.067-1.84a1.334 1.334 0 011.393-.645l1.974.356c.31.056.63 0 .903-.158l2.012-1.16c.272-.159.48-.408.588-.705l.678-1.887a1.334 1.334 0 011.243-.883h2.134z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 19.668a3.668 3.668 0 100-7.336 3.668 3.668 0 000 7.336z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSettings;